export { default as ContactStyle } from './Contact.module.scss';
